<template>
  <div class="container">
    <div v-if="list3&&list3.length > 0">
      <div class="notification" v-for="item in list3" :key="item.msgId">
        <div class="content">
          <div class="lastLine">
            【{{item.eventName}}】
            <router-link v-if="item.resMap&&item.resMap.resId&&item.resMap.is_valid!==0" target="_blank" :to="{path:'/activity',query:{id:item.resMap.resId}}">《{{item.resMap.title}}》</router-link>
            <a href="javascript:;" @click="tipsDel" v-if="item.resMap&&item.resMap.resId&&item.resMap.is_valid===0">《{{item.resMap.title}}》</a>
          </div>
        </div>
        <hr />
      </div>
      <div class="page" v-if="page.allPage&&page.allPage>1">
          <a-pagination
              v-model:current="page.currentPage"
              :total="page.allSize"
              :show-total="total => `共 ${page.allSize} 篇`"
              :pageSize="page.pageSize"
              show-quick-jumper
              @change="changePage"
              />
      </div>
    </div>
    <div class="img" v-else>
      <img src="../../assets/img/notification.png" alt="" />
      <span style="display:block;margin-top:20px;font-size:16px">您还没有通知</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed,onMounted,toRefs,reactive} from "vue";
import Http from "../../until/http";
import { useRoute } from "vue-router";
import config from "../../until/configs";
import { messageTips } from "../../until/tools";
export default defineComponent({
  props: {
    list3: [],
  },
    setup() {
    const imgSiteUrl = computed(() => {
      return config.imgSiteUrl;
    });
     const route = useRoute();
     const state = reactive({
      list3:[],
      page:{}
    });
    let userId = computed(() => {
      return route.query.userId;
    });

    const changePage = (e)=>{
      Http.getNotification({
          msgType: 2,
          currentPage: e,
          userId: userId.value,
        }).then((res) => {
          if (res) {
            state.list3 = res.messageEntities;
            state.page = res.totalPages;
            window.scrollTo(0,0)
          }
        });
    }

    const tipsDel = ()=>{
      messageTips('该活动已删除',2);
    }

    onMounted(() => {
        Http.getNotification({
          msgType: 2,
          currentPage: 1,
          userId: userId.value,
        }).then((res) => {
          if (res) {
            state.list3 = res.messageEntities;
            state.page = res.totalPages;
          }
        });
    });
    return { 
      imgSiteUrl ,
      userId, 
      ...toRefs(state),
      changePage,
      tipsDel
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
.container {
  width: 1200px;
  .notification {
    overflow: hidden;
    margin-top: 15px;
    img {
      float: left;
      margin-right: 10px;
      width: 49px;
      height: 49px;
      border-radius: 50%;
    }
    .content {
      margin-bottom: 30px;
      .fristLine {
        overflow: hidden;
        .title {
          float: left;
          font-size: 16px;
          color: #333;
        }
        .time {
          float: right;
          margin-right: 50px;
          font-size: 15px;
          color: #666;
        }
      }
      .lastLine{
        color: #666;
        font-size: 15px;
        a:hover {
          color:$primary-color;
        }
      }
    }
    hr {
      border: 0.5px solid #f0f0f0;
    }
  }
  .img {
    width: 120px;
    margin: 20% auto;
    text-align: center;
    img{
      width: 120px;
      margin-bottom: 10px;
    }
  }
  .page {
    text-align: center;
    padding-top: 40px;
    padding-bottom:20px;
  }
}
</style>